import * as React from "react";
const IconCo = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 0h513v342H0z" />
    <path  d="M0 256.5h513V342H0z" />
    <path  d="M0 171h513v85.5H0z" />
  </svg>
);
export default IconCo;
